import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import About from "./About";
import ViewCompanyDetailsHeader from "./ViewClientDetailsHeader";
import SubNavbar from "../../../layout/SubNavbar/index";

export default function ViewTournamentDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const clientData = location?.state?.clientData;
  const [step, setStep] = useState(1);

  const handleStepChange = (newStep) => setStep(newStep);

  return (
    <div className="content">
      <div className="container-fluid">
        <SubNavbar
          title={`Tournament Details`}
          header={`Tournament`}
          subHeader={`View Tournament Details`}
        />
        <div className="card rounded-3 mt-3">
          <div className="card-body">
            <div className="d-flex justify-content-start">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => navigate(-1)}
              >
                <i className="bi bi-arrow-left"></i> Back
              </button>
            </div>
            {/* Images Section */}
            <div className="row mb-4">
              <div className="col-md-6 text-center">
                <h5>Tournament Image</h5>
                <img
                  src={clientData?.tournament_image}
                  alt="Tournament Logo"
                  className="img-fluid img-thumbnail"
                  style={{
                    width: "150px",
                    height: "150px",
                    borderRadius: "10%",
                  }}
                />
              </div>

              <div className="col-md-6 text-center">
                <h5>Letter Image</h5>
                <img
                  src={clientData?.latter_image}
                  alt="Letter Image"
                  className="img-fluid img-thumbnail"
                  style={{
                    width: "150px",
                    height: "150px",
                    borderRadius: "10%",
                  }}
                />
              </div>

            </div>

            <div className="d-flex justify-content-center">
              <div className="card w-75 mt-2 shadow-lg">
                <div className="card-body">
                  <div className="row">
                    {/* Left Side (Column 1) */}
                    <div className="col-md-6">
                      <div className="mb-3">
                        <h5>Tournament Title</h5>
                        <p>{clientData?.tournament_title || "N/A"}</p>
                      </div>

                      <div className="mb-3">
                        <h5>Winning Points</h5>
                        <p>{clientData?.wining_point || "N/A"}</p>
                      </div>

                      <div className="mb-3">
                        <h5>Required Points</h5>
                        <p>{clientData?.required_point || "N/A"}</p>
                      </div>

                      <div className="mb-3">
                        <h5>Start Date</h5>
                        <p>{clientData?.start_date || "N/A"}</p>
                      </div>

                      <div className="mb-3">
                        <h5>Description</h5>
                        <p>{clientData?.description || "N/A"}</p>
                      </div>
                    </div>

                    {/* Right Side (Column 2) */}
                    <div className="col-md-6">
                      <div className="mb-3">
                        <h5>Image Title</h5>
                        <p>{clientData?.image_title || "N/A"}</p>
                      </div>

                      <div className="mb-3">
                        <h5>Skip Points</h5>
                        <p>{clientData?.skip_point || "N/A"}</p>
                      </div>

                      <div className="mb-3">
                        <h5>Max Participation</h5>
                        <p>{clientData?.max_participation || "N/A"}</p>
                      </div>

                      <div className="mb-3">
                        <h5>End Date</h5>
                        <p>{clientData?.end_date || "N/A"}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center mt-4">
              <button
                className="btn btn-primary m-1"
                onClick={() =>
                  navigate("/manage_tournament/edit_tournament", {
                    state: { clientData },
                  })
                }
              >
                Edit Tournament
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
